import { NgClass, NgIf } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  viewChild
} from '@angular/core';
import {
  BookWidgetSearchModalMachCoreComponent,
  RecentListItem
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  GenericAction,
  PredictiveSearch,
  SelectedData,
  Tab
} from '@com-delta-omnichannel/mach';
import {
  PredictiveSearchItemSelectionEventData,
  SearchModalEvent,
  SearchModalEventType
} from '../../../../models/search-modal-events-object.interface';
import { ErrorStateDirective } from '../../directive';

@Component({
  standalone: true,
  selector: 'idp-connection-picker-mach-core',
  templateUrl: './connection-picker-mach-core.component.html',
  imports: [
    BookWidgetSearchModalMachCoreComponent,
    NgIf,
    ErrorStateDirective,
    NgClass
  ]
})
export class ConnectionPickerMachCoreComponent {
  @Input() connection!: { connectionCity: string; connectionAirport: string };
  @Input() recentSearchList: RecentListItem[] = [];
  @Input() savedSearchList: string[] = [];
  @Input() searchModalTabs: Tab[] = [];
  @Input() predictiveSearchData!: PredictiveSearch;
  @Input() placeholder!: string;
  @Input() helpIconAriaLabel = '';
  @Input() isFullscreen = false;
  @Input() routeIndex = 0;
  @Input() set connectionError(errors: { errorMessage: string }[] | undefined) {
    if (errors && errors.length > 0) {
      this.errorMessage = errors[this.routeIndex].errorMessage;
    }
  }

  @Output() searchModalEvent = new EventEmitter<
    SearchModalEvent<SearchModalEventType>
  >();

  @Output() searchModalTriggerClicked = new EventEmitter<SelectedData>();

  @Output() showConnectionAirportInfoModal = new EventEmitter();
  @Output() clearConnectionAirport = new EventEmitter();
  protected connectionPicker =
    viewChild.required<ElementRef<HTMLDivElement>>('connectionPicker');

  modalOpen = false;
  errorMessage = '';

  handleModalEvents(event: SearchModalEvent<SearchModalEventType>) {
    this.searchModalEvent.emit(event);
  }

  handleSearchModalTrigger() {
    this.modalOpen = true;
    this.searchModalTriggerClicked.emit({
      type: 'connection',
      selectedResult: {
        cityCode: this.connection.connectionAirport,
        cityName: this.connection.connectionCity,
        region: ''
      }
    });
  }

  handlePredictiveSearchItemSelection(eventData: GenericAction<string>) {
    const data: PredictiveSearchItemSelectionEventData = {
      airportCode: eventData.id,
      airportCity: eventData.label,
      locationType: 'connection',
      flightIndex: this.routeIndex
    };

    this.searchModalEvent.emit({
      type: 'predictiveSearchItemSelected',
      data
    });
  }

  handleSearchModalClose(searchText: string) {
    if (searchText) {
      this.handlePredictiveSearchItemSelection({
        label: searchText.toUpperCase(),
        id: searchText.toUpperCase(),
        value: ''
      });
    }

    this.modalOpen = false;
    this.connectionPicker().nativeElement.focus();
  }

  clearConnectionAirportHandler(event: Event) {
    this.clearConnectionAirport.emit();
    event.stopPropagation();
  }

  showConnectionAirportInfoModalHandler(event: Event) {
    this.showConnectionAirportInfoModal.emit();
    event.stopPropagation();
  }
}
